// The CONFIGURED instance, not bare axios: its request interceptor attaches the bearer token. Bare axios
// has no interceptor, so the call goes out unauthenticated and the AI service answers
// 401 "Not authenticated" — which created a run row with no task behind it, stuck QUEUED forever with
// nothing to poll or cancel. An absolute URL bypasses the instance's baseURL, which is exactly how
// ai.service.js calls this same service.
import axios from "../axios";
import assert from "utils/assert";
import { REACT_APP_AI_API_URL } from "./ai.service";
import { normalizeFileinfoId } from "utils/fileinfoIds";

/**
 * Start a Foundation Data v2 extraction.
 *
 * Kept in its own small file, and it is the ONLY place on the frontend that knows which service runs the
 * agent. That is what makes the choice reversible: if extraction moves to the data-sorting service, this
 * file changes and nothing else does.
 *
 * Returns the AI service's Task, whose `id` is what AIProgressWidget polls. The durable record is the
 * Java-side run row — the agent reports progress and results there, so the task is only the live view.
 *
 * @param {{runId: (number|string), year: number, fileinfoId: (number|string)}} params
 */
export function postFoundationExtract({ runId, year, fileinfoId }) {
  assert(REACT_APP_AI_API_URL, "REACT_APP_AI_API_URL is not set - check .env file");
  assert(runId != null, "runId is required", runId);
  assert(fileinfoId != null, "fileinfoId is required", fileinfoId);
  // fileinfo ids are numeric bigints in Java but string-keyed in the AI service; a raw value crossing that
  // boundary is a live bug class in this codebase, so normalise here rather than at the call site.
  const body = {
    run_id: String(runId),
    year,
    fileinfo_id: normalizeFileinfoId(fileinfoId),
  };
  return axios.post(`${REACT_APP_AI_API_URL}/foundation-extract`, body, {}).then(({ data }) => data);
}

export default postFoundationExtract;
